'use strict'

/**
 * Manage sliders
 * @module slider
 */

/** @const {string} */
const SELECTOR_PREV = 'div.top-gal .nav-gal.prev'
/** @const {string} */
const SELECTOR_NEXT = 'div.top-gal .nav-gal.next'
/** @const {string} */
const ATTRIBUTE_ORIGINAL = 'data-original'



/** @module slider/slider */
import sliderHandler from '../utils/sliderHandler'

export default {
  
  /**
   * Initiate sliders
   * @method init
   * @return {void}
   */
  init(settings) {
    sliderHandler(settings)
    
    // Lazyload for last images
    const sliderImages = settings.mainGallery.querySelectorAll('img')
    const imgSlider = sliderImages[sliderImages.length - 1]
    
    if (imgSlider && imgSlider.getAttribute(ATTRIBUTE_ORIGINAL)) {
      imgSlider.setAttribute('src', imgSlider.getAttribute(ATTRIBUTE_ORIGINAL))
      imgSlider.removeAttribute(ATTRIBUTE_ORIGINAL)
    }
  },
  
  /**
   * Click left
   *
   * @function left
   * @return {void}
   */
  left() {
    document.querySelector(SELECTOR_PREV).click()
  },
  
  /**
   * Click right
   *
   * @function right
   * @return {void}
   */
  right() {
    document.querySelector(SELECTOR_NEXT).click()
  }
}



// WEBPACK FOOTER //
// ./src/apps/Front/private/js/components/slider.js